import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardById, updateDashboard } from '../../../store/actions/dashsActions';
import { fetchUsers } from '../../../store/actions/usersActions';
import { fetchGroups } from '../../../store/actions/groupsActions';
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import Input from '../../../components/general/Input/Input';
import Textarea from '../../../components/general/Textarea/Textarea';
import TableUserForm from '../../../components/intern/TableInform/TableUserForm'; // CRIE ESTE COMPONENTE
import TitleSectionComponent from '../../../components/intern/TitleSectionComponent/TitleSectionComponent';
import CheckBoxContainer from '../../../components/general/CheckBox/CheckBoxContainer';
import Button from '../../../components/general/Button/Button';
import AlertComponent from '../../../components/intern/Alert/Alert';
import ConfirmExitModal from '../../../components/ConfirmExitModal/ConfirmExitModal';
import './UserSearchList.css';

const EditarDashboardPage = () => {
    const [showConfirmExit, setShowConfirmExit] = useState(false);
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        dashboardName: "",
        dashboardDescription: "",
        url: "",
        selectedReaderIds: [],
        selectedGroupIds: []
    });

    const [errors, setErrors] = useState({
        dashboardName: "",
        url: ""
    });

    const [searchState, setSearchState] = useState({
        readerSearchTerm: "",
        filteredUsers: [],
        selectedReaderObjects: []
    });

    const [alert, setAlert] = useState(null);
    const alertTimeoutId = useRef(null);

    const [isUpdating, setUpdating] = useState(false);
    const [updateError, setUpdateError] = useState(null);
    const [initialData, setInitialData] = useState(null);

    // CORREÇÃO: Seletores Redux ajustados
    const dashsState = useSelector((state) => state.dashs);
    const {
        currentDashboard,
        loading: loadingDashboard,
        error: errorDashboard
    } = dashsState || {};

    const {
        users: allUsers,
        loading: loadingUsers,
        error: errorUsers
    } = useSelector((state) => state.users);

    const {
        groups: allGroups,
        loading: loadingGroups,
        error: errorGroups
    } = useSelector((state) => state.groups);

    useEffect(() => {
        dispatch(fetchUsers());
        dispatch(fetchGroups());
        if (id) {
            dispatch(fetchDashboardById(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (currentDashboard && allUsers && allGroups) {
            const readersInSystem = currentDashboard.data.readers?.filter(uid => allUsers.some(u => u.uid === uid)) || [];
            const groupsInSystem = currentDashboard.data.groups?.filter(uid => allGroups.some(g => g.uid === uid)) || [];

            const initialReaders = allUsers.filter(user => readersInSystem.includes(user.uid));
            setFormData({
                dashboardName: currentDashboard.data.dashboardName || "",
                dashboardDescription: currentDashboard.data.dashboardDescription || "",
                url: currentDashboard.data.dashboardUrl || "",
                selectedReaderIds: readersInSystem,
                selectedGroupIds: groupsInSystem
            });
            setSearchState(prev => ({
                ...prev,
                selectedReaderObjects: initialReaders
            }));

            setInitialData({
                dashboardName: currentDashboard.data.dashboardName || "",
                dashboardDescription: currentDashboard.data.dashboardDescription || "",
                url: currentDashboard.data.dashboardUrl || "",
                readers: [...readersInSystem].sort(),
                groups: [...groupsInSystem].sort(),
            });
        }
    }, [currentDashboard, id, allUsers, allGroups]);


    const showAlert = (type, message) => {
        // Limpa timeout anterior
        if (alertTimeoutId.current) {
            clearTimeout(alertTimeoutId.current);
        }
        setAlert({ type, message });

        alertTimeoutId.current = setTimeout(() => {
            setAlert(null);
            alertTimeoutId.current = null;
        }, 5000);
    };


    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };

        if (formData.dashboardName.length < 3) {
            newErrors.dashboardName = "O nome do dashboard precisa ter no mínimo 3 caracteres.";
            isValid = false;
        } else {
            newErrors.dashboardName = "";
        }

        if (formData.url) {
            try {
                new URL(formData.url);
                newErrors.url = "";
            } catch (_) {
                newErrors.url = "URL inválida.";
                isValid = false;
            }
        } else {
            newErrors.url = "";
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));

        if (field === 'dashboardName' && value.length < 3) {
            setErrors(prev => ({ ...prev, dashboardName: "O nome do dashboard precisa ter no mínimo 3 caracteres." }));
        } else if (field === 'dashboardName') {
            setErrors(prev => ({ ...prev, dashboardName: "" }));
        }
    };

    const handleReaderSearch = (term) => {
        console.log(allUsers)
        setSearchState(prev => ({
            ...prev,
            readerSearchTerm: term,
            filteredUsers: term.length > 0 && allUsers
                ? allUsers.filter(user =>
                    user.userName.toLowerCase().includes(term.toLowerCase()) ||
                    user.userEmail.toLowerCase().includes(term.toLowerCase())
                )
                : []
        }));
    };

    const handleAddReader = (userToAdd) => {
        if (!formData.selectedReaderIds.includes(userToAdd.uid)) {
            setFormData(prev => ({
                ...prev,
                selectedReaderIds: [...prev.selectedReaderIds, userToAdd.uid]
            }));
            setSearchState(prev => ({
                ...prev,
                selectedReaderObjects: [...prev.selectedReaderObjects, userToAdd],
                readerSearchTerm: "",
                filteredUsers: []
            }));
        } else {
            showAlert('excluir', 'Usuário já é leitor deste dashboard.');
        }
    };

    const handleRemoveReader = (userIdToRemove) => {
        setFormData(prev => ({
            ...prev,
            selectedReaderIds: prev.selectedReaderIds.filter(id => id !== userIdToRemove)
        }));

        setSearchState(prev => ({
            ...prev,
            selectedReaderObjects: prev.selectedReaderObjects.filter(user => user.uid !== userIdToRemove)
        }));

        showAlert('excluir', 'Leitor removido da lista com sucesso.');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUpdating(true);
        setUpdateError(null);

        if (!validateForm() || !formData.dashboardName || !formData.url) {
            showAlert('erro', 'Por favor, corrija os erros e preencha os campos obrigatórios.');
            setUpdating(false);
            return;
        }

        const dashboardData = {
            id,
            dashboardName: formData.dashboardName,
            dashboardDescription: formData.dashboardDescription,
            dashboardUrl: formData.url,
            readers: formData.selectedReaderIds,
            groups: formData.selectedGroupIds,
        };

        try {
            await dispatch(updateDashboard(dashboardData)).unwrap();
            showAlert('editar', 'Dashboard atualizado com sucesso!');
            navigate("/gerenciar");
        } catch (error) {
            console.error("Erro ao atualizar Dashboard:", error);
            setUpdateError(error.message || 'Erro desconhecido');
            showAlert('erro', `Erro ao atualizar dashboard: ${error.message || 'Tente novamente.'}`);
        } finally {
            setUpdating(false);
        }
    };

    const handleBackClick = () => {
        const hasChanges =
            formData.dashboardName !== initialData?.dashboardName ||
            formData.dashboardDescription !== initialData?.dashboardDescription ||
            formData.url !== initialData?.url ||
            JSON.stringify([...formData.selectedReaderIds].sort()) !== JSON.stringify(initialData?.readers) ||
            JSON.stringify([...formData.selectedGroupIds].sort()) !== JSON.stringify(initialData?.groups);

        if (hasChanges) {
            setShowConfirmExit(true); // abre modal
        } else {
            navigate("/gerenciar"); // sai direto
        }
    };


    if (loadingDashboard || loadingUsers || loadingGroups) return <p>Carregando dados...</p>;
    if (errorDashboard || errorUsers || errorGroups) return <p>Erro ao carregar dados: {errorDashboard?.message || errorUsers?.message || errorGroups?.message}</p>;
    if (id && !currentDashboard) return <p>Dashboard não encontrado.</p>;
    return (
        <section className="container-extern content-with-sidebar">
            <FontAwesomeIcon
                icon={faArrowLeft}
                size="lg"
                style={{ cursor: "pointer", marginTop: "8px" }}
                onClick={handleBackClick}
            />


            <TitlePage
                title="Editar Dashboard"
                subtitle="Atualize e gerencie as configurações do dashboard de forma prática e segura."
            />

            <Helmet>
                <title>Edit Dashboard</title>
            </Helmet>

            <form onSubmit={handleSubmit}>
                <Input
                    type="text"
                    label="Nome do Dashboard:"
                    value={formData.dashboardName}
                    onChange={(e) => handleInputChange('dashboardName', e.target.value)}
                    placeholder="Digite o nome do dashboard"
                    errorMessage={errors.dashboardName}
                />

                <Textarea
                    label="Descrição:"
                    value={formData.dashboardDescription}
                    onChange={(e) => handleInputChange('dashboardDescription', e.target.value)}
                    placeholder="Digite a descrição do dashboard (opcional)"
                    rows={3}
                />

                <Input
                    type="url"
                    label="URL do Dashboard:"
                    value={formData.url}
                    onChange={(e) => handleInputChange('url', e.target.value)}
                    placeholder="https://seu.dashboard.url"
                    errorMessage={errors.url}
                />

                <TitleSectionComponent>Leitores (Usuários com acesso)</TitleSectionComponent>
                <Input
                    type="text"
                    placeholder="Buscar usuário por nome ou e-mail..."
                    value={searchState.readerSearchTerm}
                    onChange={(e) => handleReaderSearch(e.target.value)}
                    label="Adicionar Leitor:"
                />

                {searchState.filteredUsers.length > 0 && (
                    <ul className="user-search-list common-list-style">
                        {searchState.filteredUsers.map((user) => (
                            <li key={user.uid} onClick={() => handleAddReader(user)} className="user-search-item">
                                {user.userName} ({user.userEmail})
                            </li>
                        ))}
                    </ul>
                )}

                <TitleSectionComponent>Leitores associados ao dashboard:</TitleSectionComponent>
                {searchState.selectedReaderObjects.length > 0 ? (
                    <TableUserForm
                        dados={searchState.selectedReaderObjects}
                        onExcluir={handleRemoveReader}
                    />
                ) : (
                    <p>Nenhum leitor selecionado.</p>
                )}


                <TitleSectionComponent>Grupos associados ao dashboard: </TitleSectionComponent>
                {allGroups?.length > 0 ? (
                    <CheckBoxContainer
                        options={allGroups.map(group => ({
                            label: group.groupName,
                            value: group.uid
                        }))}
                        onChange={(newSelected) => handleInputChange('selectedGroupIds', newSelected)}
                        initialValues={formData.selectedGroupIds}
                    />
                ) : <p>Nenhum grupo disponível para seleção.</p>}

                <div className="section-btn-page">
                    <Button
                        type="submit"
                        variant="save"
                        className='btn-add'
                        disabled={
                            isUpdating ||
                            !initialData ||
                            (
                                formData.dashboardName === initialData.dashboardName &&
                                formData.dashboardDescription === initialData.dashboardDescription &&
                                formData.url === initialData.url &&
                                JSON.stringify([...formData.selectedReaderIds].sort()) === JSON.stringify(initialData.readers) &&
                                JSON.stringify([...formData.selectedGroupIds].sort()) === JSON.stringify(initialData.groups)
                            )
                        }
                    >
                        {isUpdating ? "Salvando..." : "Salvar Dashboard"}
                    </Button>
                </div>

                {alert && <AlertComponent type={alert.type} message={alert.message} onClose={() => setAlert(null)} />}
                {updateError && <p className="error-message">Erro ao atualizar dashboard: {updateError}</p>}
            </form>

            <ConfirmExitModal
                isOpen={showConfirmExit}
                onConfirm={() => navigate("/gerenciar")}
                onCancel={() => setShowConfirmExit(false)}
            />

        </section>
    );
};

export default EditarDashboardPage;